import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../../services/usuarios_login";
import { getMeAdmin } from "../../services/admin/accesos_admin";
import PantallaCarga from "../../components/admin/PantallaCarga";

function Login() {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [entrando, setEntrando] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (entrando) return;

    setError("");
    setEntrando(true);

    const resultado = await loginAdmin(usuario, password);
    if (!resultado?.ok) {
      localStorage.removeItem("usuario_token");
      setError(resultado?.data?.message || "Invalid username or password");
      setEntrando(false);
      return;
    }
    const token =
      resultado?.data?.token ||
      resultado?.data?.access_token ||
      resultado?.data?.jwt ||
      resultado?.data?.data?.token;
  
    if (!token) {
      localStorage.removeItem("usuario_token");
      // "No se recibio token del backend" no le dice nada a quien entra:
      // el detalle tecnico va a la consola, en pantalla algo accionable.
      console.error("Login sin token en la respuesta:", resultado?.data);
      setError("Could not sign in. Please try again.");
      setEntrando(false);
      return;
    }
  
    localStorage.setItem("usuario_token", token);
    localStorage.setItem("newSession", "1");
  
    navigate("/administrator_jx677");
  };

  return (
    <>
      {entrando && (
        <PantallaCarga mensaje="Signing in..." tema="oscuro" fijo />
      )}

    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        /* Columna: el logo y el formulario se centran como un solo bloque. El
           logo estaba absoluto en top:-50px, que lo dejaba cortado arriba y
           encimado con el resplandor. */
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "26px",
        background: "linear-gradient(180deg, #0C1B2F, #07121F 70%)",
        padding: "20px",
        overflow: "hidden",
      }}
    >
      {/* Resplandor de arriba. Va primero y sin puntero para que quede detras
          del logo y del formulario, no encima. */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "340px",
          /* Termina en transparente dentro de la caja. Antes cortaba a los
             100px con color todavia visible, y ese corte se veia como una
             linea cruzando la pantalla. */
          background:
            "radial-gradient(70% 100% at 50% 0%, rgba(73,163,255,0.18), rgba(73,163,255,0) 72%)",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      <img
        src="/image/ADC-Logo.png"
        alt="ADC Aircraft Service & Parts"
        style={{
          position: "relative",
          zIndex: 1,
          // En pantallas angostas 300px se come el ancho: se achica con ellas.
          width: "min(300px, 62vw)",
          display: "block",
          opacity: 0.93,
        }}
      />

      <form
        onSubmit={handleLogin}
        style={{
          position: "relative",
          zIndex: 1,
          width: "min(360px, 100%)",
          // Sin esto el padding se suma al ancho y la tarjeta se desborda en
          // pantallas angostas.
          boxSizing: "border-box",
          background: "#0E1F33",
          padding: "35px",
          borderRadius: "14px",
          border: "1px solid rgba(255,255,255,0.05)",
          boxShadow: "0px 15px 40px rgba(0,0,0,0.4)",
          color: "white",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "25px",
            fontSize: "22px",
            fontWeight: "700",
            letterSpacing: "1px",
            color: "#7AA8C5",
          }}
        >
          Access Account
        </h2>

        {/* Solo letras rojas. La caja con fondo y borde pesaba mas que el
            mensaje y movia el formulario cada vez que aparecia. */}
        {error && (
          <p
            role="alert"
            style={{
              margin: "-8px 0 16px",
              color: "#FF7B7B",
              fontSize: "13.5px",
              lineHeight: 1.45,
              textAlign: "center",
            }}
          >
            {error}
          </p>
        )}

        <label style={{ fontSize: "14px", fontWeight: "600" }}>Username</label>
        <input
          type="text"
          required
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
          style={{
            width: "100%",
            boxSizing: "border-box",
            padding: "12px",
            marginTop: "6px",
            marginBottom: "18px",
            borderRadius: "6px",
            border: "1px solid rgba(255,255,255,0.12)",
            background: "rgba(255,255,255,0.06)",
            color: "white",
            fontSize: "15px",
          }}
        />

        <label style={{ fontSize: "14px", fontWeight: "600" }}>Password</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            width: "100%",
            boxSizing: "border-box",
            padding: "12px",
            marginTop: "6px",
            borderRadius: "6px",
            border: "1px solid rgba(255,255,255,0.12)",
            background: "rgba(255,255,255,0.06)",
            color: "white",
            fontSize: "15px",
          }}
        />

        <button
          type="submit"
          disabled={entrando}
          style={{
            width: "100%",
            marginTop: "25px",
            padding: "12px",
            background: "linear-gradient(90deg, #1D5B89, #3E82AF)",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: entrando ? "not-allowed" : "pointer",
            opacity: entrando ? 0.6 : 1,
            fontWeight: "700",
            letterSpacing: "1px",
            transition: "0.3s ease",
          }}
          onMouseOver={(e) => {
            if (entrando) return;
            e.target.style.background = "linear-gradient(90deg, #2A6FA2, #5AADE0)";
            e.target.style.boxShadow = "0 0 12px rgba(90,173,224,0.6)";
          }}
          onMouseOut={(e) => {
            e.target.style.background = "linear-gradient(90deg, #1D5B89, #3E82AF)";
            e.target.style.boxShadow = "none";
          }}
        >
          {entrando ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
    </>
  );
}

export default Login;
